module.exports = __webpack_public_path__ + "img/decoration_orange.64aaa949.svg";